import { Dialog } from '@vizit/molecules';
import { AvcConnectStep } from './avc-connect-modal.types';
import { useAvcConnect } from './provider/avc-connect.context';
import { StepError } from './steps/step-error';
import { StepIntro } from './steps/step-intro';

function AvcConnectModal() {
  const { isOpen, close, step, isRedirecting } = useAvcConnect();

  return (
    <Dialog isOpen={isOpen} onOpenChange={(open) => !open && close()}>
      <Dialog.Overlay isDismissable={!isRedirecting}>
        <Dialog.Content
          isDismissable={!isRedirecting}
          aria-label="Connect Amazon Vendor Central"
          className="max-w-xl"
          dialogClassName="gap-8"
        >
          {step === AvcConnectStep.Intro && <StepIntro />}
          {step === AvcConnectStep.Error && <StepError />}
        </Dialog.Content>
      </Dialog.Overlay>
    </Dialog>
  );
}

export { AvcConnectModal };
